import Constants from "../../constants";

export interface UserListFilterIF {
	limit: number;
	page?: number;
	name?: string;
	phoneNum?: string;
	email?: string;
	reviewCount?: number;
	rejectedCount?: number;
	verifiedCount?: number;
	isVerified?: boolean;
}

export const emptyUserListFilter: UserListFilterIF = {
	limit: Constants.PAGE_SIZE,
	page: 1,
	name: '',
	phoneNum: '',
	email: '',
	reviewCount: 0,
	rejectedCount: 0,
	verifiedCount: 0,
	isVerified: true,
};

export interface BaechaBlockRes {
	createDate: any;
	createUser: string;
	groupName: string;
	groupId: string;
	id: string;
	memberId: string;
	name: string;
	reason?: string;
	targetGroupId?: string;
	targetGroupName?: string;
	targetPhoneNum?: string;
	targetUserName?: string;
	updateDate: any;
	updateUser: string;
	userId: string;

	// 편의상 추가
	deleteBtn?: any;
}